import { forwardRef, type ButtonHTMLAttributes } from 'react';

// C1 : bouton natif sans chrome. Sert à convertir les surfaces cliquables
// historiquement en <div onClick> (ni focusables ni opérables au clavier)
// sans changer leur rendu : le style vient de l'appelant, seul le reset du
// chrome navigateur est fait ici. type='button' par défaut (jamais un submit
// implicite dans un <form>).
export const Pressable = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  function Pressable({ style, type, ...rest }, ref) {
    return (
      <button
        ref={ref}
        type={type ?? 'button'}
        {...rest}
        style={{
          background: 'transparent',
          border: 'none',
          padding: 0,
          margin: 0,
          font: 'inherit',
          color: 'inherit',
          textAlign: 'inherit',
          cursor: 'pointer',
          ...style,
        }}
      />
    );
  },
);
